<script>
export default {
	name: 'ProductPrevPrice',
	props: {
		amount: Number,
		currency: String,
		customClass: {
			type: String,
			default: 'grey--text',
		},
		priceClass: {
			type: String,
			default: 'grey--text',
		},
	},
}
</script>

<template>
	<del :class="customClass">
		<PriceText :priceClass="priceClass" :amount="amount" :currency="currency" />
	</del>
</template>

<style>
.grey--text {
	color: grey !important;
}
</style>
